import { IRequestTab } from './types';

export const tabs: IRequestTab[] = [
  { tab: 'brands', countKey: 'requestsBrandsCount' },
  { tab: 'points', countKey: 'requestsPointsCount' },
  { tab: 'products', countKey: 'requestsProductsCount' },
  // TODO - remove hide when catalogues requests are implemented
  { tab: 'catalogues', countKey: 'requestsCataloguesCount', hide: true }, // This tab is hidden in the UI,
];
